import { MasterDetailListEntry } from '@sdbn/common';
import { ArticleType } from '../article-types/article-type.model';
import { PriceContainer } from '../erp-common/erp-common.model';


export class BasicArticleListEntry implements MasterDetailListEntry {
  basicArticle: BasicArticle;
  articleType: ArticleType;
  subTitle: string;

  constructor(basicArticleListEntry: any) {
    this.basicArticle = basicArticleListEntry.basicArticle;
    this.articleType = basicArticleListEntry.articleType;
    this.subTitle = basicArticleListEntry.subTitle;
  }

  public get childs(): MasterDetailListEntry[] {
    return null;
  }
  public get groupIdentifier(): string {
    return null;
  }

  public get listTitle(): string {
    return null;
  }

  public get listTitleDictionaryKey(): string {
      return this.articleType?.name?.dictionaryKey;
  }

  public get listSubTitle(): string {
    return this.subTitle;
  }
}

export class BasicArticle  {

  id: number;
  archived = false;
  articleTypeId: number;
  priceContainer = new PriceContainer({});
  map = new Map();
  attributeValues = new Array<BasicArticleAttributeValue>();


  constructor(article: any) {
      this.id = article.id;
      this.archived = article.archived === true;
      this.articleTypeId = article.articleTypeId;
      if (article.priceContainer != null) {
          this.priceContainer = new PriceContainer(article.priceContainer);
      }
      if (article.attributeValues != null) {
          for (const value of article.attributeValues) {
              const newValue = new BasicArticleAttributeValue(value);
              this.attributeValues.push(newValue);
              this.map.set(newValue.attributeId, newValue);
          }
      }
  }

  public getValueByAttributeId(attributeId: number): BasicArticleAttributeValue {
      for (const value of this.attributeValues) {
          if (value.attributeId === attributeId) {
              return value;
          }
      }
      return null;
  }

  public addValue(value: BasicArticleAttributeValue) {
      this.attributeValues.push(value);
      this.map.set(value.attributeId, value);
  }

}

export class BasicArticleAttributeValue {

  id: number;

  attributeId: number;

  value: string;

  constructor(attribute: any) {
      this.id = attribute.id;
      this.attributeId = attribute.attributeId;
      this.value = attribute.value;
  }

}
